import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'delivery-details',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER_DELIVERY":[
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'proforma-invoice-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'shippingNotice/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
    }
}
const state = () => ({
    shippingNotice: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.shippingNotice.pageConfig,
    getPageConfigTree: state => state.shippingNotice.pageConfigTree,
    getPageKey:state => state.shippingNotice.pageKey,
    getPushDataDialog:state => state.shippingNotice.dialogPage,
    getPushDataPageKey:state => state.shippingNotice.dialogPage.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.shippingNotice.resetPage = data;
    },
    setLoading(state, data){
        state.shippingNotice.loading = data;
        if(isNotEmpty(state.shippingNotice.pageConfig)){
            Object.keys(state.shippingNotice.pageConfig).forEach((key,index)=>{
                state.shippingNotice.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.shippingNotice.pageConfig = data.pageConfig;
        state.shippingNotice.pageConfigTree = data.allArrData;
        state.shippingNotice.pageKey = getRandomString();
        if(isNotEmpty(state.shippingNotice.pageConfig)){
            Object.keys(state.shippingNotice.pageConfig).forEach((key,index)=>{
                state.shippingNotice.pageConfig[key].height = state.shippingNotice.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.shippingNotice.dialogPage.pageConfig = data.pageConfig;
        state.shippingNotice.dialogPage.pageConfigTree = data.allArrData;
        state.shippingNotice.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.shippingNotice.dialogPage.pageConfig)){
            Object.keys(state.shippingNotice.dialogPage.pageConfig).forEach((key,index)=>{
                state.shippingNotice.dialogPage.pageConfig[key].height = state.shippingNotice.height
            })
        }
    },
    setPushDialogList(state, data){
        state.shippingNotice.dialogPage.pageConfig[data.obj].data = data.data;
        state.shippingNotice.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.shippingNotice.pageConfig[data.obj].data = data.data;
        state.shippingNotice.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.shippingNotice.height = (data) + 'px';
        if(isNotEmpty(state.shippingNotice.pageConfig)){
            Object.keys(state.shippingNotice.pageConfig).forEach((key,index)=>{
                state.shippingNotice.pageConfig[key].height = state.shippingNotice.height;
            })
        }
        state.shippingNotice.dialogPage.height = (data) + 'px';
        if(isNotEmpty(state.shippingNotice.dialogPage.pageConfig)){
            Object.keys(state.shippingNotice.dialogPage.pageConfig).forEach((key,index)=>{
                state.shippingNotice.dialogPage.pageConfig[key].height = state.shippingNotice.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.shippingNotice.pageConfig,pageConfigTree:state.shippingNotice.pageConfigTree});
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.shippingNotice.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__shipping", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.shippingNotice.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.shippingNotice.tableName,top_tools:state.shippingNotice.top_tools,pageUrl:'shipping-notice'});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.shippingNotice.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.shippingNotice.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__shipping_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
